<footer class="footer-v2">
  <img class="footer-v2__decor" :src="stoolsImage" alt="" aria-hidden="true" />
  <div class="footer-v2__inner">
    <div class="footer-v2__brand">
      <div class="footer-v2__brand-head">
        <router-link :to="{ name: 'Home' }" class="footer-v2__brand-link">
          <img :src="brandLogo" :alt="brandTitle" />
          <strong>{{ brandTitle }}</strong>
        </router-link>
        <div class="footer-v2__controls">
          <LanguageSwitcher footer />
          <button
            type="button"
            class="footer-v2__theme-btn"
            :aria-label="themeButtonLabel"
            @click="toggleTheme"
          >
            <i :class="themeIconClass"></i>
          </button>
        </div>
      </div>
      <p>{{ $t('footer.description') }}</p>
    </div>

    <nav class="footer-v2__nav" :aria-label="$t('footer.navigation')">
      <h2>{{ $t('footer.navigation') }}</h2>
      <div>
        <router-link :to="{ name: 'Home' }">{{ $t('navigation.home') }}</router-link>
        <router-link :to="{ name: 'AllClubs' }">{{ $t('navigation.clubs') }}</router-link>
        <router-link :to="{ name: 'Features' }">{{ $t('navigation.features') }}</router-link>
        <router-link :to="{ name: 'About' }">{{ $t('navigation.about') }}</router-link>
        <router-link :to="{ name: 'Pricing' }">{{ $t('navigation.pricing') }}</router-link>
        <router-link :to="{ name: 'About', hash: '#contacts' }">{{ $t('footer.contacts') }}</router-link>
      </div>
    </nav>

    <nav class="footer-v2__nav" :aria-label="$t('footer.useful')">
      <h2>{{ $t('footer.useful') }}</h2>
      <div>
        <a :href="documentationHref">{{ $t('footer.documentation') }}</a>
        <router-link :to="{ name: 'Features' }">{{ $t('navigation.features') }}</router-link>
        <router-link :to="{ name: 'About' }">{{ $t('footer.platform') }}</router-link>
        <router-link :to="{ name: 'PublicSearch' }">{{ $t('navigation.search') }}</router-link>
      </div>
    </nav>

    <div v-if="showSocialLinks" class="footer-v2__social">
      <h2>{{ $t('footer.social') }}</h2>
      <div>
        <a href="#" aria-label="Telegram"><i class="bi bi-telegram"></i></a>
        <a href="#" aria-label="Instagram"><i class="bi bi-instagram"></i></a>
        <a href="#" aria-label="Facebook"><i class="bi bi-facebook"></i></a>
      </div>
    </div>

    <div class="footer-v2__bottom">
      <a
        class="footer-v2__developer"
        href="https://sharkdevelop.com"
        target="_blank"
        rel="noopener"
      >
        <span class="footer-v2__developer-logo" aria-hidden="true">
          <img :src="developerLogo" alt="" />
        </span>
        {{ $t('footer.developedBy') }}
      </a>
      <small>© 2026 {{ brandTitle }}</small>
    </div>
  </div>
</footer>
